import { render, staticRenderFns } from "./BalanceLevelDetailTab.vue?vue&type=template&id=492c6eaa&scoped=true"
import script from "./BalanceLevelDetailTab.vue?vue&type=script&lang=js"
export * from "./BalanceLevelDetailTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceLevelDetailTab.vue?vue&type=style&index=0&id=492c6eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c6eaa",
  null
  
)

export default component.exports